import axios from "axios";

const instance = axios.create({
     baseURL: "https://api.nidaulquran.com/"
     // baseURL: "http://54.186.118.166:5500/"
	// baseURL: "http://localhost:5500/"
});

export default instance;
